/**
 * Payment endpoints owned by this module.
 *
 * The four commit endpoints that PHP serves live in `shared/constants.ts:API`
 * because they carry an `IS_DEV` fixture switch; these are the ones that never
 * had one. They were inline template literals scattered through `payment.api.ts`
 * until this file collected them.
 *
 * ⚠ Deliberately no `IS_DEV` branch here. Adding fixture switching to endpoints
 * that never had it would change how the app behaves in development, which is a
 * behaviour change and not this commit's job.
 */
export const PAYMENT_ENDPOINTS = {
    LOYALTY: '/loyalty',
    APPLE_PAYMENT: '/api/paymentApple',
    MYPOS_SESSION_START: '/api/paymentMyPosStart',
    TBC_SESSION_START: '/api/paymentTbcStart',
    MIAPAY_SESSION_START: '/api/paymentMiaPayStart',
} as const;
